import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Store, Menu, LayoutDashboard, Users, LogOut, UtensilsCrossed, Settings } from 'lucide-react';

export const DashboardLayout = ({ children, onSignOut }: { children: React.ReactNode, onSignOut: () => void }) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const location = useLocation();

    const navLinks = [
        { path: '/xm-console', label: 'Overview', icon: LayoutDashboard },
        { path: '/xm-console/establishments', label: 'Establishments', icon: Store },
        { path: '/xm-console/users', label: 'Staff Members', icon: Users },
        { path: '/xm-console/menu-categories', label: 'Menu Categories', icon: UtensilsCrossed },
        { path: '/xm-console/settings', label: 'Admin Settings', icon: Settings },
    ];

    return (
        <div className="admin-dashboard">
            <div className="dashboard-layout">
                <aside className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
                    <div style={{ padding: '24px', borderBottom: '1px solid var(--border-light)', display: 'flex', alignItems: 'center' }}>
                        <img src="/icon.svg" alt="Ordabell" style={{ height: '24px', width: '24px', marginRight: '12px' }} />
                        <h2 style={{ fontSize: '1.125rem', fontFamily: 'var(--font-display)', color: 'var(--text-primary)', margin: 0 }}>Ordabell Admin</h2>
                    </div>

                    <nav style={{ flex: 1, paddingTop: '24px' }}>
                        {navLinks.map((link) => {
                            const Icon = link.icon;
                            const isActive = link.path === '/xm-console'
                                ? location.pathname === '/xm-console'
                                : location.pathname.startsWith(link.path);

                            return (
                                <Link
                                    key={link.path}
                                    to={link.path}
                                    className={`nav-link ${isActive ? 'active' : ''}`}
                                    onClick={() => setIsSidebarOpen(false)}
                                >
                                    <Icon size={20} />
                                    {link.label}
                                </Link>
                            );
                        })}
                    </nav>

                    <div style={{ padding: '24px', borderTop: '1px solid var(--border-light)' }}>
                        <Link to="/" className="btn btn-outline" style={{ width: '100%', marginBottom: '12px' }}>
                            &larr; Back to Site
                        </Link>
                        <button className="btn" style={{ width: '100%', color: 'var(--text-secondary)' }} onClick={onSignOut}>
                            <LogOut size={18} /> Sign Out
                        </button>
                    </div>
                </aside>

                <main className="main-content">
                    <header className="top-header">
                        <button className="mobile-toggle" onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
                            <Menu size={24} color="var(--text-primary)" />
                        </button>
                        <div style={{ marginLeft: 'auto' }}>
                            <span style={{ fontSize: '0.875rem', color: 'var(--text-secondary)' }}>Super Admin Portal</span>
                        </div>
                    </header>

                    <div className="page-container">
                        {children}
                    </div>
                </main>
            </div>
        </div>
    );
};
